import { render, staticRenderFns } from "./quick-menu.vue?vue&type=template&id=686af272&scoped=true&"
import script from "./quick-menu.vue?vue&type=script&lang=js&"
export * from "./quick-menu.vue?vue&type=script&lang=js&"
import style0 from "./quick-menu.vue?vue&type=style&index=0&id=686af272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686af272",
  null
  
)

export default component.exports